import { jsx as _jsx } from "react/jsx-runtime";
import "./three-dots-pulse.scss";
const ThreeDotsPulse = () => {
    return (_jsx("div", Object.assign({ className: "stage" }, { children: _jsx("div", { className: "dot-pulse" }) })));
};
export default ThreeDotsPulse;
